import React, { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Grid,
  useMediaQuery,
  useTheme,
  Typography,
} from "@mui/material";
import { WSIcons } from "../../commonFunctions/iIcons";

const SearchNoCharge: React.FC<{ open: boolean; onClose: () => void }> = ({
  open,
  onClose,
}) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  // State for managing text field input and keyboard mode
  const [inputValue, setInputValue] = useState("");
  const [isSymbolMode, setIsSymbolMode] = useState(false); // Toggles between letters and symbols

  // Handler for when a virtual key is clicked
  const handleKeyClick = (key: string) => {
    setInputValue((prevValue) => prevValue + key);
  };

  // Handler for backspace and other special keys
  const handleSpecialKeyClick = (key: string) => {
    if (key === "OK") {
      // Handle submit action here if needed (e.g., sending the search query)
      console.log("Search submitted:", inputValue);
    } else if (key === "?123") {
      // Toggle between letters and numbers/symbols
      setIsSymbolMode((prevMode) => !prevMode);
    } else if (key === "BACKSPACE") {
      // Remove the last character from the input
      setInputValue((prevValue) => prevValue.slice(0, -1));
    }
  };

  // Define keyboard layouts
  const letterKeys = [
    ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P"],
    ["A", "S", "D", "F", "G", "H", "J", "K", "L"],
    ["Z", "X", "C", "V", "B", "N", "M"],
  ];

  const symbolKeys = [
    ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"],
    ["!", "@", "#", "$", "%", "^", "&", "*", "(", ")"],
    ["-", "_", "=", "+", "[", "]", "{", "}", ";", ":"],
  ];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      maxWidth="md"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          maxHeight: "90vh", // Limit the dialog's height to 90% of the viewport
        },
      }}
    >
      <DialogTitle sx={{ backgroundColor: "green" }}>
        <Grid display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" color={"white"}>
            Search
          </Typography>
          <IconButton onClick={onClose}>
            <WSIcons.CloseIcon sx={{ color: "white" }} />
          </IconButton>
        </Grid>
      </DialogTitle>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "100%", // Take up full height of dialog
          mt:2
        }}
      >
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Type something..."
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          sx={{ mb: 2 }}
        />
        <Box sx={{ height: "150px", backgroundColor: "#f0f0f0", mb: 2 }}>
          {/* This area can be used for displaying search results */}
        </Box>
        <Grid container spacing={1} justifyContent="center" sx={{ mb: 2 }}>
          {/* Virtual keyboard */}
          {(isSymbolMode ? symbolKeys : letterKeys).map((row, rowIndex) => (
            <Grid container key={rowIndex} justifyContent="center">
              {row.map((key, index) => (
                <Grid item key={index} xs={1} sm={1}>
                  <Button
                    variant="outlined"
                    fullWidth
                    sx={{ height: 50, minWidth: 50 }}
                    onClick={() => handleKeyClick(key)}
                  >
                    {key}
                  </Button>
                </Grid>
              ))}
            </Grid>
          ))}
          <Grid container justifyContent="center" sx={{ mt: 2 }}>
            <Button
              variant="contained"
              sx={{ mx: 1 }}
              onClick={() => handleSpecialKeyClick("?123")}
            >
              ?123
            </Button>
            <Button
              variant="contained"
              sx={{ mx: 1 }}
              onClick={() => handleSpecialKeyClick("BACKSPACE")}
            >
              <WSIcons.BackspaceIcon/>
            </Button>
            <Button
              variant="contained"
              sx={{ mx: 1 }}
              onClick={() => handleSpecialKeyClick("OK")}
            >
              OK
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
      <Grid
        item
        sx={{
          backgroundColor: "#333",
          padding: "1rem",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Grid container spacing={2} alignItems="center" gap={3}>
          <Grid item>
            <WSIcons.GTranslateIcon sx={{ color: "white" }} />
          </Grid>
        </Grid>

        <Button
          variant="contained"
          sx={{
            backgroundColor: "green",
            "&:hover": {
              backgroundColor: "#388e3c",
            },
          }}
          onClick={() => handleSpecialKeyClick("OK")}
        >
          OK
        </Button>
      </Grid>
    </Dialog>
  );
};

export default SearchNoCharge;
